import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const AvatarMenuContainer = styled.div`
    padding: 0 ${token('space.100', '8px')};
    /*
        Because the avatar component sets multiple levels
        of divs with display: flex or display: inline-flex,
        to get the right height we need to force it here.
     */
    height: ${grid.multiple(4.5).px};
`;
